export function drawLogisticsEventsTable(
  pdf,
  traceabilityData,
  startY,
  margin
) {
  if (traceabilityData.length === 0) {
    pdf.setFont("helvetica", "bold");
    pdf.setFontSize(10);
    pdf.text(
      "En el momento de la consulta no se disponen de datos de trazabilidad logística.",
      margin + 5,
      startY + 12
    );
    return startY;
  } else {
    const pageWidth = pdf.internal.pageSize.getWidth();
    const pageHeight = pdf.internal.pageSize.getHeight();
    const rowHeight = 16;
    const safeBottomMargin = 10;

    const tableWidth = pageWidth - margin * 2;
    const colWidths = [
      tableWidth * 0.3,
      tableWidth * 0.15,
      tableWidth * 0.25,
      tableWidth * 0.3,
    ];

    const drawEventHeader = () => {
      pdf.setFont("helvetica", "bold");
      pdf.rect(margin, startY, colWidths[0], rowHeight);
      pdf.rect(margin + colWidths[0], startY, colWidths[1], rowHeight);
      pdf.rect(
        margin + colWidths[0] + colWidths[1],
        startY,
        colWidths[2],
        rowHeight
      );
      pdf.rect(
        margin + colWidths[0] + colWidths[1] + colWidths[2],
        startY,
        colWidths[3],
        rowHeight
      );

      pdf.text("Código de envío", margin + 5, startY + 12);
      pdf.text("Fecha y hora", margin + colWidths[0] + 5, startY + 12);
      pdf.text("Evento", margin + colWidths[0] + colWidths[1] + 5, startY + 12);
      pdf.text(
        "Ubicación",
        margin + colWidths[0] + colWidths[1] + colWidths[2] + 5,
        startY + 12
      );

      startY += rowHeight;
    };

    drawEventHeader();
    pdf.setFont("helvetica", "normal");

    traceabilityData.forEach((item) => {
      const texts = [
        pdf.splitTextToSize(item.shipmentCode, colWidths[0] - 10),
        pdf.splitTextToSize(item.eventDate, colWidths[1] - 10),
        pdf.splitTextToSize(item.eventName, colWidths[2] - 10),
        pdf.splitTextToSize(item.eventLocation, colWidths[3] - 10),
      ];

      const maxLines = Math.max(...texts.map((t) => t.length));
      const currentRowHeight = maxLines * rowHeight;

      // Página nueva si no cabe
      if (startY + currentRowHeight + safeBottomMargin > pageHeight - margin) {
        pdf.addPage();
        startY = margin;
        drawEventHeader();
      }

      // Dibujar celdas
      pdf.rect(margin, startY, colWidths[0], currentRowHeight);
      pdf.rect(margin + colWidths[0], startY, colWidths[1], currentRowHeight);
      pdf.rect(
        margin + colWidths[0] + colWidths[1],
        startY,
        colWidths[2],
        currentRowHeight
      );
      pdf.rect(
        margin + colWidths[0] + colWidths[1] + colWidths[2],
        startY,
        colWidths[3],
        currentRowHeight
      );

      // Dibujar textos por celda
      texts.forEach((lines, i) => {
        const x = margin + colWidths.slice(0, i).reduce((a, b) => a + b, 0) + 5;
        lines.forEach((line, j) => {
          const yOffset = 12 + j * rowHeight;
          pdf.text(line, x, startY + yOffset);
        });
      });

      startY += currentRowHeight;
    });
  }
}
